import { render, staticRenderFns } from "./EventDate.vue?vue&type=template&id=267432e2&scoped=true"
import script from "./EventDate.vue?vue&type=script&lang=js"
export * from "./EventDate.vue?vue&type=script&lang=js"
import style0 from "./EventDate.vue?vue&type=style&index=0&id=267432e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267432e2",
  null
  
)

export default component.exports